import { connect } from 'react-redux'
import SmallNav, {
  Values,
  Callbacks
} from '../../components/smallNav/smallNavComponent'
import { State } from '../../redux/reducers/'

// Global State
export function mapStateToProps (state: State, props): Values {
  return {
    myPlan: state.gradPlanner.savedPlan,
    betaCorner: true,
    siteMaintBlockLogin: false,
    siteMaintBlockRegistration: false,
    siteMaintBlockGradPlanner: false
  }
}

export const propsMapping: Callbacks = {}

export default connect(mapStateToProps, propsMapping)(SmallNav)



// WEBPACK FOOTER //
// ./src/containers/smallNav/smallNavContainer.js